const hostname = window.location.hostname;
const stageHostnames = ["localhost", "127.0.0.1"];

const baseMap = {
  "customer-test.finhub.habilelabs.io": "https://backend-test.finhub.habilelabs.io/api",
  "finhub-stage.habilelabs.io": "https://backend-stage.finhub.habilelabs.io/api",
  "customer.finhub.habilelabs.io": "https://backend-v2.finhub.habilelabs.io/api"
};

export const baseURL = stageHostnames.includes(hostname)
  ? "https://backend-test.finhub.habilelabs.io/api"
  : baseMap[hostname] || "https://backend.finhub.habilelabs.io/api";
  
export const createHeaders = () => {
  const token = sessionStorage.getItem("authToken");
  return {
    Authorization: "Bearer " + token,
  };
};

export const onscreenTestHeaders = () => {
  let apiKey = sessionStorage.getItem("apiKey");
  let apiSecret = sessionStorage.getItem("apiSecret");

  if (!apiKey || !apiSecret) {
    const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
    if (userDetails) {
      apiKey = userDetails.apiKey;
      apiSecret = userDetails.apiSecret;
    }
  }

  return {
    api_key: apiKey,
    api_secret: apiSecret,
  };
};

